import * as STD                            from '@emersya/mpa-std-lib';

import CM                                  from '@emersya/mpa-components-manager-lib';
import { Block, InputBool }                from '@emersya/mpa-components-lib';
import ViewerComponent, { NS as ViewerNS } from '../../../viewer/Viewer/Viewer';
import { NS as StorageNS } 					from '../StandingStorage/StandingStorage';
// import * as Emersya                        from '@libs/MPAApplication/index';
// import * as PlannerNS                      from '../../../viewer/planner/Planner/ViewerPlanner';

export interface IStandingBannerConfortComponentConfiguration extends Block.Configuration {
	text : STD.translationsManager.TranslationMapping;

};

export class StandingBannerConfortComponent extends Block.Component {
	static override initialize() {
		super.initialize();
	};

	readonly plannerCategory! : ViewerComponent.ProductCategory;
	viewerNode : ViewerComponent.ProductInstance | null = null;
	firstInstance : boolean = true;
	isBannerUp : boolean = true;

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	async remove(){
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		if (!app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		if (this.viewerNode) {
			await this.viewerNode.delete();
			this.viewerNode = null;
		}
		const bannerPart = app.basket.basket.currentProduct.parts.find(x => x.id === 'bannerConfort');
		if (bannerPart) {
			await app.basket.basket.currentProduct.getPart([ 'bannerConfort' ]).remove();
		}
	};

	async onProductChange_before(){
		await this.remove();
		this.firstInstance = true;
	};

	private computeMatrix() {
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available in arch!');
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available in arch');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part in arch');
		}
		const layoutId = layoutCurrentOption.id;
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		if (!app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		const wdh = this.getWDH();
		const x = wdh.width;
		// const y = wdh.height;
		const z = wdh.depth;
		const storageComponent = <StorageNS.Component>this.component_parent;
		if(!storageComponent.deduceAdequateStorage()){
			return (ViewerNS.Component.mtx(
				[ 0, 0, 0 ],
				[ 0, 0, 0 ],
				0
			));
		}
		const storage = app.component_configuration.productsComponents.find(x => x.type === 'storage' && x.SKU === 'storage'+storageComponent.deduceAdequateStorage());
		if (!storage) {
			throw STD.errors.user('No storage found');
		}
		const boundingBoxStorage = storage.boundingBox;
		if (!boundingBoxStorage) {
			throw STD.errors.user('Missing bounding box for storage ');
		}
		if (layoutId === 'shape-no-wall') {
			return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
		} else if (layoutId === 'shape-back-left') {
			if(storageComponent.isStorage){
				return (ViewerNS.Component.mtx(
					[ -x/2+boundingBoxStorage.depth/2, 0, -z/2+boundingBoxStorage.width+0.001 ],
					[ 1, 1, 1 ],
					180
				));
			}else{
				return (ViewerNS.Component.mtx(
					[ -x/2+boundingBoxStorage.depth/2, 0, -z/2+0.001 ],
					[ 1, 1, 1 ],
					180
				));
			}
		} else if (layoutId === 'shape-back') {
			if(storageComponent.isStorage){
				return (ViewerNS.Component.mtx(
					[ -x/2+boundingBoxStorage.depth/2, 0, -z/2+boundingBoxStorage.width+0.001 ],
					[ 1, 1, 1 ],
					180
				));
			}else{
				return (ViewerNS.Component.mtx(
					[ -x/2+boundingBoxStorage.depth/2, 0, -z/2+0.001 ],
					[ 1, 1, 1 ],
					180
				));
			}
		} else if (layoutId === 'shape-back-right') {
			if(storageComponent.isStorage){
				return (ViewerNS.Component.mtx(
					[ x/2 - boundingBoxStorage.width - 0.001, 0, -z/2+ boundingBoxStorage.depth/2],
					[ 1, 1, 1 ],
					90
				));
			}else{
				return (ViewerNS.Component.mtx(
					[ x/2 - 0.001, 0, -z/2+ boundingBoxStorage.depth/2],
					[ 1, 1, 1 ],
					90
				));
			}
			
		} else if (layoutId === 'shape-left-back-right') {
			if(storageComponent.isStorage){
				return (ViewerNS.Component.mtx(
					[ -x/2+boundingBoxStorage.depth/2, 0, -z/2+boundingBoxStorage.width+0.001 ],
					[ 1, 1, 1 ],
					180
				));
			}else{
				return (ViewerNS.Component.mtx(
					[ -x/2+boundingBoxStorage.depth/2, 0, -z/2+0.001 ],
					[ 1, 1, 1 ],
					180
				));
			}
		} else {
			throw STD.errors.user('Unknown layout id in banner');
		}
	}

	async update(){
		if(!this.isBannerUp){
			return;
		}
		await app.viewer.freezeRendering({ keepCount : true });
		if (app.isReloading) {
			if (!this.viewerNode) {
				await this.insert();
			}
		} else {
			if (this.viewerNode) {
				await this.remove();
			}
			await this.insert();
		}
		await app.viewer.unfreezeRendering({ keepCount : true });
	}

	async updateWithoutRemoving(){
		if(!this.isBannerUp){
			return;
		}
		await app.viewer.freezeRendering({ keepCount : true });
		if(this.viewerNode){
			await app.viewer.batch([
				[
					'setProductNodesInstancesMatrices', [
					{
						localId : this.viewerNode.localId,
						matrix :  this.computeMatrix()
					}
				]
				]
			]);
		}
		await app.viewer.unfreezeRendering({ keepCount : true });
	}

	async insert() {
		// insert nodes
		const product = app.currentProduct;
		if (this.viewerNode || !product || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		if (product.id === 'prestige' || product.id === 'siae' || product.id === 'business') {
			return;
		}
		const part = product.createPart({
			id :        'bannerConfort',
			title :     'Banner Confort',
			reference : null,
			metaData :  null,
			parts :     [],
			options :   []
		});
		await part.initialize();
		const category = app.viewer.categories.find(x => x.name === 'bannerConfort');
		if (!category) {
			this.component_throwLibraryError('');
		}
		if (app.isReloading) {
			const instances = Array.from(app.viewer.safe.value.productInstances);
			const node = instances.find(x => x.product.category === category);
			if (!node) {
				return;
			}
			this.viewerNode = node;
			this.viewerNode.setName('bannerConfort');
			return;
		}
		const bannerProductSchema = this.plannerCategory.products.find(x => x.SKU === '@bannerStorageConfort');
		if (!bannerProductSchema) {
			this.component_throwLibraryError('');
		}
		this.viewerNode = await bannerProductSchema.instantiate({
			rootLocalId : app.viewer.globalLocalId,
			appendType : 'insert',
			basketPart  : [],
			basketUseDynamicTitleBinding : true,
			metadata : {
				id : this.id,
				customImages : [
					{
						enabled :   false,
						leftRight : 0,
						upDown :    0,
						resize :    1,
						rotate :    0,
						image :     null
					}
				]
			}
		});
		this.viewerNode.setName('bannerConfort');
		await app.viewer.batch([
			[
				'setProductNodesInstancesMatrices', [
				{
					localId : this.viewerNode.localId,
					matrix :  this.computeMatrix()
				}
			]
			]
		]);
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if (!inputBool) {
			throw STD.errors.user('Missing input bool in content');
		}
		if (!inputBool.value) {
			await inputBool.updateValue(true);
		}
		this.firstInstance = false;
	};

	async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		// await super.onValueUpdated(ev);
		if (ev.details.isDefaultValue) {
			return;
		}
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		;
		await app.transaction(async () => {
			if (ev.details.newValue) {
				this.isBannerUp = true;
				await this.update();
			} else {
				this.isBannerUp = false;
				await this.remove();
			}
		});
	};

	override async component_initialize() {
		await this.component_find('@:field:content').component_instantiateOuterChild({
			type :          'input-bool',
			isSlot :        false,
			declaredSlot :  null,
			id :            'options',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : <InputBool.Configuration> {
				type :            'yesno',
				defaultValue :    true,
				'@translations' : {
					checked :   {
						'en' : 'Yes',
						'fr' : 'Oui'
					},
					unchecked : {
						'en' : 'No',
						'fr' : 'Non'
					}
				}
			}
		});
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		const categoryDescriptor : ViewerComponent.ProductCategory.IDescriptor & {
			products : NonNullable<ViewerComponent.ProductCategory.IDescriptor['products']>;
		} = {
			name :        'bannerConfort',
			menuActions : {
				edit :      true,
				delete :    false,
				rotate :    false,
				duplicate : false
			},
			products :    []
		};
		
		if (app.component_configuration.products.find(x => x.SKU === 'confort')) {
			const bannerComponent = app.component_configuration.productsComponents.find(x => x.type === 'storageBannerConfort');
			if (!bannerComponent) {
				throw STD.errors.user('Missing storage banner confort component');
			}
			app.viewer.productsExtensionById[ '@bannerStorageConfort' ] = {
				quantity :     null,
				customImages : [
					{
						id :       'customImg',
						title :    { en : 'Add logo', fr : 'Ajouter un logo' },
						get width() {
							return 0.8;
						},
						get height() {
							return 0.8;
						},
						get mesh() {
							return 'Logo_reserve.001.001';
						},
						get material() {
							return {
								name : 'custom_logo_reserve_reserve',
								configuration : {
									enabled : 'custom',
									disabled : 'none'
								}
							}
						},
						getLocalId() {
							return <number> this.localId;
						},
						pricingInfo :       null,
						volumeComputation : null
					}
				],
			};
			categoryDescriptor.products.push({
				SKU :   '@bannerStorageConfort',
				nodes : [
					{
						SKU :                         <string> bannerComponent.viewerComponentSKU,
						projectCode :                 <string> bannerComponent.viewerProjectCode,
						localId :                     'bannerStorageConfort',
						parentLocalId :               'root',
						snappable :                   false,
						fixedPositionSetIds :         null,
						draggable :                   false,
						doNotListAsProductComponent : true,
						tracked :                     true,
						matrix :                      app.viewer.mtx(
							[ 0, 0, 0 ],
							[ 0, 0, 0 ],
							0
						)
					}
				]
			});
		}
		(<any> this).plannerCategory = app.viewer.createCategory(categoryDescriptor);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingBannerConfortComponentConfiguration
	)
	{
		configuration[ '@innerConfigurations' ] = {
			field : {
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							label : {
								'@translations' : {
									text : {
										'en' : 'I want the banner',
										'fr' : 'Je veux la bannière'
									}
								}
							}
						}
					}
				}
			}
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});

	};
};
export namespace NS {
	export const Component = StandingBannerConfortComponent;
	export type Component = StandingBannerConfortComponent;
	export type Configuration = IStandingBannerConfortComponentConfiguration;
}
import manifestXMLSource                   from './StandingBannerConfort.xml';
import './StandingBannerConfort.scss';

CM.declare({
	id :       'standing-bannerConfort',
	type :     StandingBannerConfortComponent,
	manifest : manifestXMLSource
});
